<app-header [forceLightBackground]="true"></app-header>
<div class="admin-access-requests">
  <div class="admin-access-requests--layout">
    <app-admin-sidebar class="admin-access-requests--sidebar"></app-admin-sidebar>
    <div class="admin-access-requests--content">
      <app-page-header></app-page-header>
      <div class="access-requests-container">
        <app-asset-request
          [showActionColumn]="false"
          [showPurposeColumn]="false"
          [showRequestTypeColumn]="false"
          [hideHorizontalScroll]="true"
          (reloadData)="loadAssetRequests()"
        ></app-asset-request>
      </div>
    </div>
  </div>
</div>
